/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreatePtAtcudSeriesBody,
  Error,
  GetActivePtAtcudSeriesParams,
  ListPtAtcudSeriesParams,
  PtAtcudSeries,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Create a Portugal ATCUD series registration for one PT document type.
 * @summary Create PT ATCUD series
 */
export type createPtAtcudSeriesResponse201 = {
  data: PtAtcudSeries
  status: 201
}

export type createPtAtcudSeriesResponse400 = {
  data: Error
  status: 400
}

export type createPtAtcudSeriesResponse401 = {
  data: Error
  status: 401
}

export type createPtAtcudSeriesResponse403 = {
  data: Error
  status: 403
}

export type createPtAtcudSeriesResponse404 = {
  data: Error
  status: 404
}

export type createPtAtcudSeriesResponse422 = {
  data: ValidationError
  status: 422
}

export type createPtAtcudSeriesResponse500 = {
  data: Error
  status: 500
}

export type createPtAtcudSeriesResponseSuccess = (createPtAtcudSeriesResponse201) & {
  headers: Headers;
};
export type createPtAtcudSeriesResponseError = (createPtAtcudSeriesResponse400 | createPtAtcudSeriesResponse401 | createPtAtcudSeriesResponse403 | createPtAtcudSeriesResponse404 | createPtAtcudSeriesResponse422 | createPtAtcudSeriesResponse500) & {
  headers: Headers;
};

export type createPtAtcudSeriesResponse = (createPtAtcudSeriesResponseSuccess | createPtAtcudSeriesResponseError)

export const getCreatePtAtcudSeriesUrl = () => {


  

  return `/fiscalization/pt/atcud-series`
}

export const createPtAtcudSeries = async (createPtAtcudSeriesBody: CreatePtAtcudSeriesBody, options?: RequestInit): Promise<createPtAtcudSeriesResponse> => {
  
  return customFetch<createPtAtcudSeriesResponse>(getCreatePtAtcudSeriesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPtAtcudSeriesBody,)
  }
);}
  

/**
 * List PT ATCUD series registered on the selected PT entity.
 * @summary List PT ATCUD series
 */
export type listPtAtcudSeriesResponse200 = {
  data: PtAtcudSeries[]
  status: 200
}

export type listPtAtcudSeriesResponse400 = {
  data: Error
  status: 400
}

export type listPtAtcudSeriesResponse401 = {
  data: Error
  status: 401
}

export type listPtAtcudSeriesResponse403 = {
  data: Error
  status: 403
}

export type listPtAtcudSeriesResponse404 = {
  data: Error
  status: 404
}

export type listPtAtcudSeriesResponse500 = {
  data: Error
  status: 500
}

export type listPtAtcudSeriesResponseSuccess = (listPtAtcudSeriesResponse200) & {
  headers: Headers;
};
export type listPtAtcudSeriesResponseError = (listPtAtcudSeriesResponse400 | listPtAtcudSeriesResponse401 | listPtAtcudSeriesResponse403 | listPtAtcudSeriesResponse404 | listPtAtcudSeriesResponse500) & {
  headers: Headers;
};

export type listPtAtcudSeriesResponse = (listPtAtcudSeriesResponseSuccess | listPtAtcudSeriesResponseError)

export const getListPtAtcudSeriesUrl = (params?: ListPtAtcudSeriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/fiscalization/pt/atcud-series?${stringifiedParams}` : `/fiscalization/pt/atcud-series`
}

export const listPtAtcudSeries = async (params?: ListPtAtcudSeriesParams, options?: RequestInit): Promise<listPtAtcudSeriesResponse> => {
  
  return customFetch<listPtAtcudSeriesResponse>(getListPtAtcudSeriesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get one PT ATCUD series by ID.
 * @summary Get PT ATCUD series
 */
export type getPtAtcudSeriesResponse200 = {
  data: PtAtcudSeries
  status: 200
}

export type getPtAtcudSeriesResponse400 = {
  data: Error
  status: 400
}

export type getPtAtcudSeriesResponse401 = {
  data: Error
  status: 401
}

export type getPtAtcudSeriesResponse403 = {
  data: Error
  status: 403
}

export type getPtAtcudSeriesResponse404 = {
  data: Error
  status: 404
}

export type getPtAtcudSeriesResponse500 = {
  data: Error
  status: 500
}

export type getPtAtcudSeriesResponseSuccess = (getPtAtcudSeriesResponse200) & {
  headers: Headers;
};
export type getPtAtcudSeriesResponseError = (getPtAtcudSeriesResponse400 | getPtAtcudSeriesResponse401 | getPtAtcudSeriesResponse403 | getPtAtcudSeriesResponse404 | getPtAtcudSeriesResponse500) & {
  headers: Headers;
};

export type getPtAtcudSeriesResponse = (getPtAtcudSeriesResponseSuccess | getPtAtcudSeriesResponseError)

export const getGetPtAtcudSeriesUrl = (id: string,) => {


  

  return `/fiscalization/pt/atcud-series/${id}`
}

export const getPtAtcudSeries = async (id: string, options?: RequestInit): Promise<getPtAtcudSeriesResponse> => {
  
  return customFetch<getPtAtcudSeriesResponse>(getGetPtAtcudSeriesUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Return the current non-manual PT ATCUD series by document type, matching the legacy active-series lookup.
 * @summary Get active PT ATCUD series
 */
export type getActivePtAtcudSeriesResponse200 = {
  data: PtAtcudSeries[]
  status: 200
}

export type getActivePtAtcudSeriesResponse400 = {
  data: Error
  status: 400
}

export type getActivePtAtcudSeriesResponse401 = {
  data: Error
  status: 401
}

export type getActivePtAtcudSeriesResponse403 = {
  data: Error
  status: 403
}

export type getActivePtAtcudSeriesResponse404 = {
  data: Error
  status: 404
}

export type getActivePtAtcudSeriesResponse500 = {
  data: Error
  status: 500
}

export type getActivePtAtcudSeriesResponseSuccess = (getActivePtAtcudSeriesResponse200) & {
  headers: Headers;
};
export type getActivePtAtcudSeriesResponseError = (getActivePtAtcudSeriesResponse400 | getActivePtAtcudSeriesResponse401 | getActivePtAtcudSeriesResponse403 | getActivePtAtcudSeriesResponse404 | getActivePtAtcudSeriesResponse500) & {
  headers: Headers;
};

export type getActivePtAtcudSeriesResponse = (getActivePtAtcudSeriesResponseSuccess | getActivePtAtcudSeriesResponseError)

export const getGetActivePtAtcudSeriesUrl = (params?: GetActivePtAtcudSeriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/fiscalization/pt/atcud-series/active?${stringifiedParams}` : `/fiscalization/pt/atcud-series/active`
}

export const getActivePtAtcudSeries = async (params?: GetActivePtAtcudSeriesParams, options?: RequestInit): Promise<getActivePtAtcudSeriesResponse> => {
  
  return customFetch<getActivePtAtcudSeriesResponse>(getGetActivePtAtcudSeriesUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

